import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../i18n/hooks';
import './SurebetListEmpty.css';

/**
 * SurebetListEmpty - Empty state when no surebets are available
 * Shows a friendly message with illustrations
 */
const SurebetListEmpty = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div 
      className={`surebet-list-empty ${className}`}
      role="status"
      aria-label={t('surebets.list.noData')}
    >
      <div className="surebet-list-empty__container">
        {/* Illustration */}
        <div className="surebet-list-empty__illustration">
          <svg
            className="surebet-list-empty__icon"
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 7V10L12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Message */}
        <h2 className="surebet-list-empty__title">
          {t('surebets.list.noDataTitle')}
        </h2>
        <p className="surebet-list-empty__description">
          {t('surebets.list.noDataDescription')}
        </p>

        {/* Tips */}
        <div className="surebet-list-empty__tips">
          <h3 className="surebet-list-empty__tips-title">
            {t('surebets.list.tips')}
          </h3>
          <ul className="surebet-list-empty__tips-list">
            <li>{t('surebets.list.tip1')}</li>
            <li>{t('surebets.list.tip2')}</li>
            <li>{t('surebets.list.tip3')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

SurebetListEmpty.propTypes = {
  className: PropTypes.string,
};

export default SurebetListEmpty;

